// src/router.jsx
import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import {
  AppstoreOutlined,
  AppstoreAddOutlined,
  HomeOutlined,
  TeamOutlined,
  ReloadOutlined,
} from '@ant-design/icons';

import Protected from '@/auth/Protected';
import MobileLayout from '@/ui/MobileLayout';

import Login from '@/pages/login/index.jsx';
import Dashboard from '@/pages/Dashboard.jsx';
import Forbidden from '@/pages/Forbidden.jsx';

import MaterialCategoriesPage from '@/pages/material-categories';
import UnitsTable from '@/pages/units';
import SuppliersTable from '@/pages/suppliers';
import MaterialsPage from '@/pages/materials';

//import UpdatePage from '@/pages/update-page';



const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/403', element: <Forbidden /> },

  {
    path: '/',
    element: (
      <Protected any={['user', 'admin']}>
        <MobileLayout />
      </Protected>
    ),

    /** Меню для MobileLayout — пункт «Оновити застосунок» ведёт на /__update */
    handle: {
      menu: [
        { to: '/', label: 'Головна', icon: <HomeOutlined /> },
        {
          label: 'Матеріали',
          icon: <AppstoreOutlined />,
          children: [
            { to: '/materials', label: 'Матеріали', icon: <AppstoreOutlined /> },
            { to: '/material-categories', label: 'Категорії матеріалів', icon: <AppstoreOutlined /> },
            { to: '/units', label: 'Одиниці виміру', icon: <AppstoreAddOutlined /> },
          ],
        },
        {
          label: 'Довідники',
          icon: <TeamOutlined />,
          children: [
            { to: '/suppliers', label: 'Постачальники', icon: <TeamOutlined /> },
          ],
        },

        // --- Системний пункт меню (форс-оновлення)
     //   { to: '/__update', label: 'Оновити застосунок', icon: <ReloadOutlined /> },
      ],
    },

    children: [
      { index: true, element: <Dashboard /> },

      // Розділ «Матеріали»
      { path: 'materials', element: <MaterialsPage /> },
      { path: 'material-categories', element: <MaterialCategoriesPage /> },
      { path: 'units', element: <UnitsTable /> },

      // Розділ «Довідники»
      { path: 'suppliers', element: <SuppliersTable /> },

      // Службова сторінка — викликає updateApp()
      //{ path: '__update', element: <UpdatePage /> },

      { path: 'admin', element: <div className="p-4">Адмін</div> },
    ],
  },

  { path: '*', element: <Navigate to="/" replace /> },
]);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
